(function () {
  function ensureSources(card, video) {
    if (video.dataset.loaded === 'true') return;
    const mp4 = card.dataset.mp4;
    const webm = card.dataset.webm;

    if (webm) {
      const source = document.createElement('source');
      source.src = webm;
      source.type = 'video/webm';
      video.appendChild(source);
    }
    if (mp4) {
      const source = document.createElement('source');
      source.src = mp4;
      source.type = 'video/mp4';
      video.appendChild(source);
    }
    video.dataset.loaded = 'true';
  }

  function pauseOtherCards(activeCard) {
    document.querySelectorAll('[data-kh-testimonial-card].is-playing').forEach(function (card) {
      if (card === activeCard) return;
      const video = card.querySelector('video');
      if (video) video.pause();
      card.classList.remove('is-playing');
    });
  }

  function toggleCard(card) {
    const video = card.querySelector('video');
    if (!video) return;

    ensureSources(card, video);
    video.muted = true;
    video.playsInline = true;
    if (video.paused) {
      pauseOtherCards(card);
      card.classList.add('is-playing');
      video.play().catch(function () {
        video.load();
        window.setTimeout(function () {
          video.play().catch(function () {
            card.classList.remove('is-playing');
          });
        }, 120);
      });
    } else {
      video.pause();
      card.classList.remove('is-playing');
    }
  }

  document.addEventListener('click', function (event) {
    const card = event.target.closest('[data-kh-testimonial-card]');
    if (card) {
      toggleCard(card);
    }
  });
})();
